"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const has_1 = __importDefault(require("lodash/has"));
const pickAnyKey = (object) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in object) {
        if ((0, has_1.default)(object, key)) {
            return key;
        }
    }
    return undefined;
};
exports.default = pickAnyKey;
//# sourceMappingURL=pickAnyKey.js.map